module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.portType == "Icd" ?
    "Handover to Rail" :
    " Gate-In at Terminal By Road"))]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  })], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-2"
  }), _vm._v(" "), (_vm.portType == 'Icd') ? _c('div', {
    staticClass: "phone-viewport mt-3",
    attrs: {
      "id": "vehicleBooking"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle",
    class: _vm.handover.handoverToRailId == '' ? 'md-active' : '',
    staticStyle: {
      "background": "darkcyan !important"
    },
    attrs: {
      "id": "showVisibility"
    },
    on: {
      "click": _vm.showOverflow
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Handover to Rail")]), _vm._v(" "), _c('md-list-expand', [_c('b-card', [_c('md-list', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Handover Party *")])], 1), _vm._v(" "), (!_vm.handover.handoverTo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.handoverTo))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted",
      "name": "permitted1",
      "md-value": "HandOverToIcd"
    },
    model: {
      value: (_vm.handover.handoverTo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "handoverTo", $$v)
      },
      expression: "handover.handoverTo"
    }
  }, [_vm._v("HandOver To ICD")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted2",
      "name": "permitted2",
      "md-value": "HandOverToCFS"
    },
    model: {
      value: (_vm.handover.handoverTo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "handoverTo", $$v)
      },
      expression: "handover.handoverTo"
    }
  }, [_vm._v("HandOver To CFS")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.handover.handoverTo == 'HandOverToCFS') ? _c('md-layout', {
    attrs: {
      "md-flex": "40",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("CFS Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cfsList,
      "id": "cfs",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select CFS"
    },
    model: {
      value: (_vm.handover.cfsId),
      callback: function($$v) {
        _vm.$set(_vm.handover, "cfsId", $$v)
      },
      expression: "handover.cfsId"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("LEO Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "date"
    },
    model: {
      value: (_vm.handover.leoDate),
      callback: function($$v) {
        _vm.$set(_vm.handover, "leoDate", $$v)
      },
      expression: "handover.leoDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Handover Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "date"
    },
    model: {
      value: (_vm.handover.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.handover, "handoverDate", $$v)
      },
      expression: "handover.handoverDate"
    }
  }), _vm._v(" "), (!_vm.handover.handoverDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.handoverDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("TR Submission Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "datetime",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.handover.trSubmitDateHandover),
      callback: function($$v) {
        _vm.$set(_vm.handover, "trSubmitDateHandover", $$v)
      },
      expression: "handover.trSubmitDateHandover"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("TR Submission Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.trModeList,
      "option-value": "tV",
      "option-text": "tT",
      "placeholder": "Select Mode "
    },
    model: {
      value: (_vm.handover.trSubmitModeHandover),
      callback: function($$v) {
        _vm.$set(_vm.handover, "trSubmitModeHandover", $$v)
      },
      expression: "handover.trSubmitModeHandover"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.handover.trSubmitModeHandover == 'Online') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Enter Details")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingBillNo",
      "name": "shippingBillNo"
    },
    model: {
      value: (_vm.handover.trModeOnline),
      callback: function($$v) {
        _vm.$set(_vm.handover, "trModeOnline", $$v)
      },
      expression: "handover.trModeOnline"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isPridel == 'Pridel') ? _c('b-card', {
    staticClass: "mt-3",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('b-card-text', [_c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Payment Details For Payment done Through\n                                    Pridel PDA")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingBillNo",
      "name": "shippingBillNo"
    },
    model: {
      value: (_vm.handover.shippingBillNo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "shippingBillNo", $$v)
      },
      expression: "handover.shippingBillNo"
    }
  })], 1), _vm._v(" "), (!_vm.handover.shippingBillNo &&
    _vm.isPridel == 'Pridel'
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.shippingBillNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Receipt No *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "receiptNo",
      "name": "receiptNo"
    },
    model: {
      value: (_vm.handover.receiptNo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "receiptNo", $$v)
      },
      expression: "handover.receiptNo"
    }
  })], 1), _vm._v(" "), (!_vm.handover.receiptNo && _vm.isPridel == 'Pridel') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.receiptNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Ammount Paid (In Rs)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ammountPaid",
      "name": "ammountPaid"
    },
    model: {
      value: (_vm.handover.ammountPaid),
      callback: function($$v) {
        _vm.$set(_vm.handover, "ammountPaid", $$v)
      },
      expression: "handover.ammountPaid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Date Of Payment :")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Time Of Payment * :")])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "date"
    },
    model: {
      value: (_vm.handover.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.handover, "paymentDate", $$v)
      },
      expression: "handover.paymentDate"
    }
  }), _vm._v(" "), (!_vm.handover.paymentDate &&
    _vm.isPridel == 'Pridel'
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.paymentDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('DatePicker', {
    attrs: {
      "lang": "en",
      "type": "time",
      "format": "HH:mm",
      "placeholder": "Select Time",
      "minute-step": 1
    },
    model: {
      value: (_vm.handover.paymentTime),
      callback: function($$v) {
        _vm.$set(_vm.handover, "paymentTime", $$v)
      },
      expression: "handover.paymentTime"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader223"
    },
    on: {
      "click": _vm.addHandoverToRail
    }
  }, [_vm._v("\n                              Save & Proceed To Rail Out")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader223"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.handover.handoverToRailId != '' || _vm.portType == 'Sea_Port') ? _c('div', {
    staticClass: "phone-viewport mt-3",
    attrs: {
      "id": "railOut"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle md-active",
    staticStyle: {
      "background": "darkcyan !important",
      "overflow": "visible"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.portType == "Icd" ?
    "Rail Out " :
    " Gate-In at Terminal By Road"))]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('div', {
    staticClass: "table-responsive mt-4"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "input": _vm.sameForAll
    },
    model: {
      value: (_vm.sameForAllSelected),
      callback: function($$v) {
        _vm.sameForAllSelected = $$v
      },
      expression: "sameForAllSelected"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container")]), _vm._v(" "), (_vm.portType != 'Sea_Port') ? _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.portType == "Sea_Port" ?
    "TR Submission Mode" :
    "Train No.") + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('th', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                TR Submission\n                              ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.portType == "Sea_Port" ?
    "Gate-In Type" :
    "Wagon  No.") + "\n                              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.portType == "Sea_Port" ?
    "Gate-In Date" :
    "Train Departure Dt. & Time") + "\n                              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.portType == "Sea_Port" ?
    "Date of Container Arrival at Port" :
    "Train Arrival Dt. & Time At Port") + "\n                              ")]), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('th', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                Vessel & Voyage Details\n                              ")]) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('th', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                Other Dates\n                              ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.containerNoList), function(item, indx) {
    return _c('tr', {
      key: indx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                                " + _vm._s(indx + 1) + " " + _vm._s(item.checked) + " "), _c('br'), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
      attrs: {
        "value": "1",
        "unchecked-value": "0"
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }), _c('br'), _vm._v(" "), (item.checked == '1') ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "light"
      },
      on: {
        "click": function($event) {
          _vm.renderForAll(indx)
        }
      }
    }, [_vm._v("Replicate")]) : _vm._e()], 1), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                                " + _vm._s(item.ContainerNo ?
      item.ContainerNo :
      item.containerNo)), _c('br'), _c('small', {
      staticStyle: {
        "visibility": "hidden"
      }
    }, [_vm._v(_vm._s(item.ffExecutionContainerId))])]), _vm._v(" "), (_vm.portType != 'Sea_Port') ? _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "size": "sm"
      },
      model: {
        value: (item.trainNo),
        callback: function($$v) {
          _vm.$set(item, "trainNo", $$v)
        },
        expression: "item.trainNo"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('td', [_c('small', [_vm._v(" TR Submission Mode")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.trModeList,
        "option-value": "tV",
        "option-text": "tT",
        "placeholder": "Select Mode "
      },
      model: {
        value: (item.trSubmitMode),
        callback: function($$v) {
          _vm.$set(item, "trSubmitMode", $$v)
        },
        expression: "item.trSubmitMode"
      }
    }), _vm._v(" "), _c('small', [_vm._v(" TR Submission Date")]), _vm._v(" "), _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.trSubmitDate),
        callback: function($$v) {
          _vm.$set(item, "trSubmitDate", $$v)
        },
        expression: "item.trSubmitDate"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.gateInTypeList,
        "option-value": "gV",
        "option-text": "gT",
        "placeholder": "Select Type"
      },
      model: {
        value: (item.gateInType),
        callback: function($$v) {
          _vm.$set(item, "gateInType", $$v)
        },
        expression: "item.gateInType"
      }
    })], 1) : _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "size": "sm"
      },
      model: {
        value: (item.wagonNo),
        callback: function($$v) {
          _vm.$set(item, "wagonNo", $$v)
        },
        expression: "item.wagonNo"
      }
    })], 1), _vm._v(" "), _c('td', [(_vm.portType == 'Sea_Port') ? _c('date-picker', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD hh:mm a ",
        "minute-step": 1
      },
      model: {
        value: (item.gateInTypeDate),
        callback: function($$v) {
          _vm.$set(item, "gateInTypeDate", $$v)
        },
        expression: "item.gateInTypeDate"
      }
    }) : _c('date-picker', {
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD hh:mm a",
        "minute-step": 1
      },
      model: {
        value: (item.trainDepartDate),
        callback: function($$v) {
          _vm.$set(item, "trainDepartDate", $$v)
        },
        expression: "item.trainDepartDate"
      }
    })], 1), _vm._v(" "), _c('td', [(_vm.portType == 'Sea_Port') ? _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.containerArivalAtPortDate),
        callback: function($$v) {
          _vm.$set(item, "containerArivalAtPortDate", $$v)
        },
        expression: "item.containerArivalAtPortDate"
      }
    }) : _c('date-picker', {
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD hh:mm a",
        "minute-step": 1
      },
      model: {
        value: (item.trainArriveDate),
        callback: function($$v) {
          _vm.$set(item, "trainArriveDate", $$v)
        },
        expression: "item.trainArriveDate"
      }
    })], 1), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('td', [_c('small', [_vm._v("Vessel")]), _vm._v(" "), _c('b-form-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "size": "sm"
      },
      model: {
        value: (item.vesselName),
        callback: function($$v) {
          _vm.$set(item, "vesselName", $$v)
        },
        expression: "item.vesselName"
      }
    }), _vm._v(" "), _c('small', [_vm._v("Voyage")]), _vm._v(" "), _c('b-form-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "size": "sm"
      },
      model: {
        value: (item.vesselVoyage),
        callback: function($$v) {
          _vm.$set(item, "vesselVoyage", $$v)
        },
        expression: "item.vesselVoyage"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('td', [_c('small', [_vm._v("Vessel Gate-Open Date")]), _vm._v(" "), _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.vesselEta),
        callback: function($$v) {
          _vm.$set(item, "vesselEta", $$v)
        },
        expression: "item.vesselEta"
      }
    }), _vm._v(" "), _c('small', [_vm._v("Vessel ETD")]), _vm._v(" "), _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.vesselEtd),
        callback: function($$v) {
          _vm.$set(item, "vesselEtd", $$v)
        },
        expression: "item.vesselEtd"
      }
    }), _vm._v(" "), _c('small', [_vm._v("LEO Date")]), _vm._v(" "), _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.gateOutDate),
        callback: function($$v) {
          _vm.$set(item, "gateOutDate", $$v)
        },
        expression: "item.gateOutDate"
      }
    })], 1) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader116"
    },
    on: {
      "click": _vm.addRailOutTables
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader116"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader116"
    },
    on: {
      "click": _vm.showSailFPOD
    }
  }, [_vm._v("Save & Proceed to Sail and FPOD")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader116"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose22
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopData",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop11212",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose11212
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c90c5b7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/newHandoverToRail.vue
// module id = 2722
// module chunks = 0